import { PROVINCES } from '../constants/common';
import { isArray, isEmpty } from './util';
import { numberFixed } from './formatter';

/**
 * @desc 根据份数求坐标最大数
 * @param max 最大数
 * @param splitNumber 分割份数
 * @param decimal 是否出现小数
 */
export function getAxisMax(max = 0, splitNumber = 5, decimal = false) {
    let average = max / splitNumber;  // 平均数
    let integer = parseInt(average, 10);
    let digit = decimal && integer === 0 ? (average).toExponential(1).match(/e[-+](\d)+/)[1] - 2 : integer.toString().length;    // 位数
    let multiple = Math.ceil(average / Math.pow(10, digit - 1));  // 合适的倍数
    return (multiple * splitNumber * Math.pow(10, digit - 1)) || (decimal ? 1 : splitNumber);
}

// 求分数纵坐标
export function getScoreAxisMax(score = 0) {
    return Math.ceil(score * 10) / 10;
}

/**
 * @desc 根据数据某个指标计算SymbolSize
 * @param data 数据
 * @param field 以哪个字段的值为计算标准
 * @param range size范围，默认[10, 30]
 */
export function calcSymbolSize(data, field, range = [10, 30]) {
    if (isEmpty(data) || isEmpty(data) || isEmpty(range)) {
        return [];
    }
    let values = data.map(d => d[field]);
    let maxValue = Math.max.apply(null, values) || 0, minValue = Math.min.apply(null, values) || 0;
    if(maxValue === minValue) { // 最大值和最小值相等时做处理
        minValue = 0;
    }
    let avg = (range[1] - range[0]) / (maxValue - minValue);

    data.forEach((d) => {
        d.symbolSize = range[0] + (d[field] - minValue) * avg;
    });
}

/**
 * @desc 填充地图数据，echarts 4.0+ 地图没设置data就取不到省份名字
 * @param data 数据
 */
export function completeMapData(data) {
    data = data || [];
    if (data.length < PROVINCES.length) {
        let isExist = {}; // 已经存在的省
        data.forEach(d => {
            isExist[d.name] = true;
        });

        PROVINCES.forEach(p => {
            if (!isExist[p]) {
                data.push({ name: p });
            }
        });
    }

    return data;
}

// 分数雷达图
export function createScoreRadarOption(data) {
    if(!(isArray(data) && data.length)) {
        return {};
    }
    data.forEach(d => {
        d.name = d.key;
        d.value = numberFixed(d.value);
        d.max = 1;
    });

    return { data };
}



// WEBPACK FOOTER //
// ./src/utils/chart.js